"use client";

import { create } from "zustand";
import { useModal } from "@/hooks/useModal";

/** The modal id, so the street-view gallery button and the modal agree. */
export const VISIT_360_MODAL_ID = "visit360";

interface Visit360Store {
  url: string | null;
  setUrl: (url: string | null) => void;
}

const useVisit360Store = create<Visit360Store>((set) => ({
  url: null,
  setUrl: (url) => set({ url }),
}));

/**
 * The full-screen 360° tour.
 *
 * A street-view media opens here rather than in the gallery: it is one immersive
 * embed that wants the whole viewport, not a slide among others.
 */
export function useVisit360Modal() {
  const { isOpen, open, close } = useModal(VISIT_360_MODAL_ID);
  const url = useVisit360Store((state) => state.url);
  const setUrl = useVisit360Store((state) => state.setUrl);

  return {
    isOpen,
    url,
    open: (url: string) => {
      setUrl(url);
      open();
    },
    close: () => {
      close();
      setUrl(null);
    },
  };
}
